import { Box, Typography, useTheme } from "@mui/material";

export default function AddRowButton({ onClick }) {
    const theme = useTheme();

    return (
        <Box 
            alignSelf={'center'} 
            height={'35px'} 
            width={'105px'} 
            padding={'5px 10px'} 
            sx={{
                backgroundColor: '#04569D',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#108DF9'
                }
            }}
            onClick={onClick}
        >
            <Typography 
                align={'center'} 
                color={theme.palette.ChannelPage?.subheader?.fontfilled || '#FFFFFF'} 
                fontSize={'18px'} 
                fontWeight={400}
            >
                Add Row
            </Typography>
        </Box>
    );
}